import BaseService from './BaseService'

export enum dailyMetricEnum {
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS = 'BUSINESS_IMPRESSIONS_DESKTOP_MAPS',
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH = 'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH',
  BUSINESS_IMPRESSIONS_MOBILE_MAPS = 'BUSINESS_IMPRESSIONS_MOBILE_MAPS',
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH = 'BUSINESS_IMPRESSIONS_MOBILE_SEARCH',
  BUSINESS_CONVERSATIONS = 'BUSINESS_CONVERSATIONS',
  BUSINESS_DIRECTION_REQUESTS = 'BUSINESS_DIRECTION_REQUESTS',
  CALL_CLICKS = 'CALL_CLICKS',
  WEBSITE_CLICKS = 'WEBSITE_CLICKS',
  BUSINESS_BOOKINGS = 'BUSINESS_BOOKINGS',
  BUSINESS_FOOD_ORDERS = 'BUSINESS_FOOD_ORDERS'
}

export interface IGetDailyMetricsTimeSeries {
  timeSeries?: ITimeSeries
}

export interface ITimeSeries {
  datedValues?: IDatedValue[]
}

export interface IDatedValue {
  date?: IDateClass
  value?: string
}

export interface IDateClass {
  year?: number
  month?: number
  day?: number
}

export type GmbMetricsInsights  = { [key in dailyMetricEnum]?: IGetDailyMetricsTimeSeries }

class IntegrationsService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  TikTok = {
    getURL: (locationId: string) =>
      this.requests.get(`/tiktok/oauth/url?locationId=${locationId}`),
    create: (queryData: { [key: string]: any; }) =>
      this.requests.post(`/tiktok/oauth/token`, queryData),
    getAddAccounts: (id: string) =>
      this.requests.get(`/tiktok/${id}/accounts`),
    upsert: (id: string, body: { [key: string]: any; }) =>
      this.requests.put(`/tiktok/${id}`, body),
    delete: (id: string) =>
      this.requests.delete(`/tiktok/${id}`),
    getByLocation: (locationId: string) =>
      this.requests.get(`/tiktok?locationId=${locationId}`),
    getForms: (id: string) =>
      this.requests.get(`/tiktok/${id}/forms`),
    subscribe: (id: string, data: { [key: string]: any }) =>
      this.requests.put(`/tiktok/${id}/subscribe`, data),
    upsertForm: (id: string, formId: string, data: { [key: string]: any }) =>
      this.requests.put(`/tiktok/${id}/forms/${formId}`, data),
  }

  GMB:{ [key: string]: any } = {
    addReviewComment: (reviewId: string, comment: string) => this.requests.post(`/gmb/reviews/${reviewId}/comment`, {comment}),
    checkBusinessScope: (locationId: string) => this.requests.get(`/gmb/oauth/scope/check?locationId=${locationId}`),
    getAccountsLocations: (locationId: string, launchPad: Boolean = false) => {
      const params = {
        locationId,
        launchPad
      }
      return this.requests.get(`/gmb/accounts`, { params })
    },
    getReportInsight: (locationId: string) => {
      const params = {
        locationId
      }
      return this.requests.get(`/gmb/report`, { params })
    },
    getMetricsInsight: (locationId: string):Promise<GmbMetricsInsights> => {
      const params = {
        locationId
      }
      return this.requests.get(`/gmb/metrics`, { params })
    },
    connect: (data: {
      locationId: string,
      gmbLocationId: string,
      gmbLocationName: string,
      gmbPlacesId: string,
      gmbLocationOnlyName: string,
      isVerified: boolean,
      enableCallTracking: boolean,
      launchpad?: boolean,
    }) => {
      return this.requests.post(`/gmb`, data)
    },
    disconnect: (locationId: string) => {
      const data = {
        locationId
      }
      return this.requests.delete(`/gmb`, { data })
    },
    refreshReviews: (locationId: string) => {
      const data = {
        locationId
      }
      return this.requests.post(`/gmb/reviews/refresh`, data)
    },
    settings: (data: { locationId: string, callTracking?: { enable: boolean}, agent?: {enable: boolean}, agentSetup?: {
      displayName: string
      welcomeMessage: string
      privacyPolicyUrl: string
    }}) => {
      return this.requests.post(`/gmb/settings`, data)
    }
  }
}

const instance = new IntegrationsService(BaseService.servicesConfig.Integrations)

export default instance
